const headerCollapse = () => {

    const header             = $('.js-website-header');
    const collapseClass      = 'website-header--collapsed';
    const expandedClass      = 'website-header--expanded';
    const expandedHeight     = 350;
    let headerCollapseHeight = header.height() * 2;

    APP.websiteWrapper.on('scroll', function(){
        //collapse header
        if(APP.websiteWrapper.scrollTop() > headerCollapseHeight){
            header.addClass(collapseClass);
        }
        else {
            header.removeClass(collapseClass);
        }
        //expand header with no bottom bar
        if ( $('.js-hero-slider').length ) {
            if(APP.websiteWrapper.scrollTop() > window.heroHeight){
                header.addClass(expandedClass);
            }
            else {
                header.removeClass(expandedClass);
            }
        }
        if ( $('.js-header-bar-to-show-element').length ) {
            if(APP.websiteWrapper.scrollTop() > window.headerBarToShowHeight){
                header.addClass(expandedClass);
            }
            else {
                header.removeClass(expandedClass);
            }
        }
    });
}